export const settings = {
  en: {
    "settings.confirm": "Confirm changes",
    "settings.language": "Language",
    "settings.change_number": "Change phone number",
    "settings.change_number_text":
      "To confirm the number, you must enter a 6-digit code that will be sent to a new phone number",
    "settings.change_password": "Change password",
    "settings.change_password_text":
      "To change the password, you must enter the old password",
    "settings.2fa": "Two-factor authentication (2FA)",
    "auth.authenticatorProgram": "Authenticator program",
    "settings.2fa_text":
      "Use authentication codes to log in and for other functions",
    "settings.2fa_text2": "You are currently using ",
    "settings.2fa_text3": "Do you want to change authentication?",
    "settings.enter_phone": "Enter new phone number",
    "settings.v_code": "Verification code",
    "settings.v_code_enter": "Enter verification code",
    "settings.your_password": "Your password",
    "settings.new_password": "New password",
    "settings.new_password_confirm": "Confirm new password",
    "settings.new_password_enter": "Confirm new password",
    "settings.password_confirm": "Confirm password",
    "settings.google_auth": "Google Authenticator",
    "settings.email_auth": "Email Authenticator",
    "settings.sms_auth": "Sms Authenticator",
    "settings.email_notifications": "Email notifications",
    "settings.company_news": "Subscribed to company news",
    "settings.change": "Configure",
    "settings.currently_using": "You are currently using",
    "settings.extra_protection": "Extra Protection",
    "settings.extra_protection_text":
      "If we notice a login from a device we don’t recognize, we’ll ask for a login code before you can access your account.",
    "settings.through_sms": "Through SMS or an Authentication App ",
    "settings.through_sms_text":
      "We’ll send a text message with a long code, or you can use a security app of choice.",
    "settings.2Step": "2-Step verification",
    "settings.verify": "Verify",
    "settings.submit_code": "Submit code",
    "settings.download_app": "Download 2FA App",
    "settings.download_app_text": "Download 2FA App",
    "settings.save_2fa": "Save 2FA Backup Key and Scan QR Code",
    "settings.save_2fa_text":
      "Please, backup your 2FArecovery key tosome offline storage, write down on apaper. Ifyour mobile device gets lost, stolen orerased, you will need this key torecover your 2FAaccess.",
    "settings.confirm_2fa": "Confirm 2FA Activation",
    "settings.2fa_enable_title": "Enable Two-Factor Authentication",
    "settings.2fa_enable_description":
      "To use 2FA, you need an authenticator app installed on your device.",
    "settings.link_auth_app_title": "Link the authentication app",
    "settings.link_auth_app_description":
      "Scan the QR code or enter the code below using your authentication app, then return to complete the setup",
    "settings.copy_key": "Copy key",
    "settings.enter_code_title":
      "Verify the new application for authentication",
    "settings.authy": "Authy",
    "settings.duo": "Duo Mobile",
    "settings.enter_2fa": "Enter the 6-digit code from your app",
    "settings.enter_2fa_label": "2FA Code from Authenticator App",
    "settings.enable_2fa": "Enable 2FA",

    "settings.2Step_text1":
      "Enter your phone number to receive the 2-step  verification code",
    "settings.2Step_text2":
      "Enter the verification code generated by your phone ending in",
    "settings.lang.en": "English",
    "settings.lang.ru": "Russian",
    "settings.lang.es": "Spanish",
    "settings.lang.ua": "Ukrainian",
    "settings.time_zone": "Time zone",
    "settings.avatar.photo": "Photo",
    "settings.avatar.upload_description": "Upload profile photo",
    "settings.avatar.delete": "Delete",
    "settings.avatar.upload": "Upload",
    "settings.avatar.select_image":
      "Please select an image (JPG, PNG, GIF or WebP)",
    "settings.avatar.file_too_large":
      "The file is too large. Maximum size: 5MB",
    "settings.active_sessions": "Active sessions",
    "settings.last_activity": "Last activity",
    "settings.ip": "IP",
    "settings.device_os": "Device/OS",
    "settings.browser": "Browser",
    "settings.country": "Country",
    "settings.city": "City",
    "settings.disabled": "Disable",
    "settings.enabled": "Enabled",
  },

  ru: {
    "settings.confirm": "Подтвердите изменения",
    "settings.language": "Язык",
    "settings.change_number": "Изменить номер телефона",
    "settings.change_number_text":
      "Для подтверждения номера необходимо ввести 6-значный код, который будет отправлен на новый номер телефона.",
    "settings.change_password": "Изменить пароль",
    "settings.change_password_text":
      "Для смены пароля необходимо ввести старый пароль",
    "settings.2fa": "Двухфакторная аутентификация",
    "auth.authenticatorProgram": "Приложение для аутентификации",
    "settings.2fa_text":
      "Помогите защитить свою учетную запись, даже если кто-то узнает ваш пароль.",
    "settings.2fa_text2": "В настоящее время вы используете",
    "settings.2fa_text3": "Вы хотите изменить аутентификацию?",
    "settings.enter_phone": "Введите новый номер телефона",
    "settings.v_code": "Код верификации",
    "settings.v_code_enter": "Введите код верификации",
    "settings.your_password": "Ваш пароль",
    "settings.new_password": "Новый пароль",
    "settings.new_password_confirm": "Подтвердите новый пароль",
    "settings.new_password_enter": "Подтвердите новый пароль",
    "settings.password_confirm": "Подтвердите пароль",
    "settings.google_auth": "Google Authenticator",
    "settings.email_auth": "Код на e-mail",
    "settings.sms_auth": "Код по SMS",
    "settings.email_notifications": "E-mail уведомления",
    "settings.company_news": "Подписаться на новости компании",
    "settings.change": "Изменить",
    "settings.currently_using": "В настоящее время вы используете",
    "settings.extra_protection": "Дополнительная защита",
    "settings.extra_protection_text":
      "Если мы заметим вход с незнакомого нам устройства, мы запросим код входа, прежде чем вы сможете получить доступ к своей учетной записи.",
    "settings.through_sms": "Через SMS или приложение для аутентификации ",
    "settings.through_sms_text":
      "Мы отправим текстовое сообщение с кодом, или вы можете использовать любое приложение безопасности по вашему выбору.",
    "settings.2Step": "2-этапная проверка",
    "settings.verify": "Проверить",
    "settings.submit_code": "Введите код",
    "settings.download_app": "Скачать 2FA приложение",
    "settings.download_app_text": "Скачать 2FA приложение",
    "settings.save_2fa": "Сохраните резервный ключ 2FA и отсканируйте QR-код",
    "settings.save_2fa_text":
      "Пожалуйста, сохраните резервную копию ключа восстановления 2FA в каком-нибудь автономном хранилище и запишите на бумаге. Если ваше мобильное устройство будет потеряно, украдено или удалено, вам понадобится этот ключ для восстановления доступа к 2FA.",
    "settings.confirm_2fa": "Подтвердить активацию 2FA",
    "settings.enter_2fa": "Введите 6-значный код 2FA",
    "settings.enter_2fa_label": "Код 2FA из приложения Authenticator",
    "settings.enable_2fa": "Включить 2FA",
    "settings.lang.en": "English",
    "settings.lang.ru": "Русский",
    "settings.lang.es": "Español",
    "settings.lang.ua": "Українська",
    "settings.time_zone": "Часовой пояс",
    //Нове

    "settings.2fa_enable_title": "Включить двухфакторную аутентификацию",
    "settings.2fa_enable_description":
      "Для использования 2FA необходимо установить приложение-аутентификатор на ваше устройство.",
    "settings.link_auth_app_title": "Привязать приложение-аутентификатор",
    "settings.link_auth_app_description":
      "Отсканируйте QR-код или введите код ниже в приложении-аутентификаторе, затем вернитесь для завершения настройки",
    "settings.copy_key": "Скопировать ключ",
    "settings.enter_code_title": "Введите код",
    "settings.authy": "Authy",
    "settings.duo": "Duo Mobile",

    "settings.2Step_text1":
      "Введите свой номер телефона для получения кода двухэтапной верификации",
    "settings.2Step_text2":
      "Введите код верификации, сгенерированный вашим телефоном и заканчивающийся на",

    "settings.avatar.photo": "Фото",
    "settings.avatar.upload_description": "Загрузите фото профиля",
    "settings.avatar.delete": "Удалить",
    "settings.avatar.upload": "Загрузить",
    "settings.avatar.select_image":
      "Пожалуйста, выберите изображение (JPG, PNG, GIF или WebP)",
    "settings.avatar.file_too_large":
      "Файл слишком большой. Максимальный размер: 5 МБ",
    "settings.active_sessions": "Активные сессии",
    "settings.last_activity": "Последняя активность",
    "settings.ip": "IP",
    "settings.device_os": "Устройство/ОС",
    "settings.browser": "Браузер",
    "settings.country": "Страна",
    "settings.city": "Город",

    "settings.disabled": "Отключить",
    "settings.enabled": "Включено",
  },

  es: {
    "settings.confirm": "Confirmar cambios",
    "settings.language": "Idioma",
    "settings.change_number": "Cambiar número de teléfono",
    "settings.change_number_text":
      "Para confirmar el número, debes ingresar un código de 6 dígitos que se enviará a un nuevo número de teléfono",
    "settings.change_password": "Cambiar contraseña",
    "settings.change_password_text":
      "Para cambiar la contraseña, debes ingresar la contraseña antigua",
    "settings.2fa": "Autenticación de dos factores",
    "auth.authenticatorProgram": "Aplicación de autenticación",
    "settings.2fa_text":
      "Ayuda a proteger tu cuenta, incluso si alguien obtiene tu contraseña.",
    "settings.2fa_text2": "Actualmente estás usando ",
    "settings.2fa_text3": "¿Quieres cambiar la autenticación?",
    "settings.enter_phone": "Ingrese el nuevo número de teléfono",
    "settings.v_code": "Código de verificación",
    "settings.v_code_enter": "Ingresar código de verificación",
    "settings.your_password": "Tu contraseña",
    "settings.new_password": "Nueva contraseña",
    "settings.new_password_confirm": "Confirmar nueva contraseña",
    "settings.new_password_enter": "Confirmar nueva contraseña",
    "settings.password_confirm": "Confirmar contraseña",
    "settings.google_auth": "Autenticador de Google",
    "settings.email_auth": "Autenticador de correo electrónico",
    "settings.sms_auth": "Autenticador de SMS",
    "settings.email_notifications": "Notificaciones por correo electrónico",
    "settings.company_news": "Suscrito a noticias de la empresa",
    "settings.change": "Cambiar",
    "settings.currently_using": "Actualmente estás usando",
    "settings.extra_protection": "Protección adicional",
    "settings.extra_protection_text":
      "Si notamos un inicio de sesión desde un dispositivo que no reconocemos, solicitaremos un código de inicio de sesión antes de que puedas acceder a tu cuenta.",
    "settings.through_sms": "A través de SMS o una aplicación de autenticación",
    "settings.through_sms_text":
      "Enviaremos un mensaje de texto con un código largo, o puedes usar una aplicación de seguridad de tu elección.",
    "settings.2Step": "Verificación de 2 pasos",
    "settings.verify": "Verificar",
    "settings.submit_code": "Enviar código",
    "settings.download_app": "Descargar aplicación 2FA",
    "settings.download_app_text": "Descargar aplicación 2FA",
    "settings.save_2fa": "Guardar clave de respaldo 2FA y escanear código QR",
    "settings.save_2fa_text":
      "Por favor, guarda tu clave de recuperación 2FA en algún almacenamiento sin conexión, escríbelo en un papel. Si tu dispositivo móvil se pierde, es robado o borrado, necesitarás esta clave para recuperar tu acceso 2FA.",
    "settings.confirm_2fa": "Confirmar activación de 2FA",
    "settings.enter_2fa": "Ingrese un código de 2FA de 6 dígitos",
    "settings.enter_2fa_label":
      "Código de 2FA de la aplicación de autenticación",
    "settings.enable_2fa": "Activar 2FA",

    "settings.2fa_enable_title": "Habilitar la autenticación de dos factores",
    "settings.2fa_enable_description":
      "Para usar 2FA, necesitas una aplicación autenticadora instalada en tu dispositivo.",
    "settings.link_auth_app_title": "Vincular la aplicación de autenticación",
    "settings.link_auth_app_description":
      "Escanea el código QR o introduce el código de abajo usando tu aplicación de autenticación y luego vuelve para completar la configuración",
    "settings.copy_key": "Copiar clave",
    "settings.enter_code_title": "Introducir código",
    "settings.authy": "Authy",
    "settings.duo": "Duo Mobile",

    "settings.2Step_text1":
      "Ingresa tu número de teléfono para recibir el código de verificación de 2 pasos",
    "settings.2Step_text2":
      "Ingresa el código de verificación generado por tu teléfono que termina en",

    "settings.lang.ru": "Ruso",
    "settings.lang.ua": "Ucraniano",
    "settings.time_zone": "Zona horaria",
    "settings.avatar.photo": "Foto",
    "settings.avatar.upload_description": "Sube una foto de perfil",
    "settings.avatar.delete": "Eliminar",
    "settings.avatar.upload": "Subir",
    "settings.avatar.select_image":
      "Por favor, seleccione una imagen (JPG, PNG, GIF o WebP)",
    "settings.avatar.file_too_large":
      "El archivo es demasiado grande. Tamaño máximo: 5 MB",
    "settings.active_sessions": "Sesiones activas",
    "settings.last_activity": "Última actividad",
    "settings.ip": "IP",
    "settings.device_os": "Dispositivo/OS",
    "settings.browser": "Navegador",
    "settings.country": "País",
    "settings.city": "Ciudad",

    "settings.disabled": "Desactivar",
    "settings.enabled": "Activado",
  },

  ua: {
    "settings.confirm": "Підтвердити зміни",
    "settings.language": "Мова",
    "settings.change_number": "Змінити номер телефону",
    "settings.change_number_text":
      "Щоб підтвердити номер, потрібно ввести 6-значний код, який буде надіслано на новий номер телефону",
    "settings.change_password": "Змінити пароль",
    "settings.change_password_text":
      "Щоб змінити пароль, потрібно ввести старий пароль",
    "settings.2fa": "Двофакторна автентифікація",
    "auth.authenticatorProgram": "Програма автентифікації",
    "settings.2fa_text":
      "Допомагає захистити ваш обліковий запис, навіть якщо хтось отримає ваш пароль.",
    "settings.2fa_text2": "Ви зараз використовуєте",
    "settings.2fa_text3": "Бажаєте змінити автентифікацію?",
    "settings.enter_phone": "Введіть новий номер телефону",
    "settings.v_code": "Код підтвердження",
    "settings.v_code_enter": "Введіть код підтвердження",
    "settings.your_password": "Ваш пароль",
    "settings.new_password": "Новий пароль",
    "settings.new_password_confirm": "Підтвердьте новий пароль",
    "settings.new_password_enter": "Підтвердьте новий пароль",
    "settings.password_confirm": "Підтвердьте пароль",
    "settings.google_auth": "Google Authenticator",
    "settings.email_auth": "Email Authenticator",
    "settings.sms_auth": "SMS Authenticator",
    "settings.email_notifications": "Сповіщення електронною поштою",
    "settings.company_news": "Підписка на новини компанії",
    "settings.change": "Змінити",
    "settings.currently_using": "Ви зараз використовуєте",
    "settings.extra_protection": "Додатковий захист",
    "settings.extra_protection_text":
      "Якщо ми помітимо вхід з незнайомого пристрою, ми запросимо код для входу перед доступом до вашого облікового запису.",
    "settings.through_sms": "Через SMS або додаток автентифікації",
    "settings.through_sms_text":
      "Ми надішлемо текстове повідомлення з довгим кодом або ви можете використати обраний додаток безпеки.",
    "settings.2Step": "Двоетапна перевірка",
    "settings.verify": "Підтвердити",
    "settings.submit_code": "Надіслати код",
    "settings.download_app": "Завантажити додаток 2FA",
    "settings.download_app_text": "Завантажити додаток 2FA",
    "settings.save_2fa":
      "Збережіть ключ резервного копіювання 2FA та відскануйте QR-код",
    "settings.save_2fa_text":
      "Будь ласка, збережіть ключ відновлення 2FA у офлайн-сховищі, запишіть на папері. Якщо ваш мобільний пристрій загубиться, буде вкрадений або видалений, вам знадобиться цей ключ для відновлення доступу до 2FA.",
    "settings.confirm_2fa": "Підтвердити активацію 2FA",
    "settings.enter_2fa": "Введіть 6-значний код 2FA",
    "settings.enter_2fa_label": "Код 2FA з додатку автентифікації",
    "settings.enable_2fa": "Увімкнути 2FA",

    "settings.2fa_enable_title": "Увімкнути двофакторну автентифікацію",
    "settings.2fa_enable_description":
      "Для використання 2FA потрібно встановити застосунок-автентифікатор на вашому пристрої.",
    "settings.link_auth_app_title": "Підключити застосунок автентифікації",
    "settings.link_auth_app_description":
      "Відскануйте QR-код або введіть код нижче в застосунку автентифікації, після чого поверніться для завершення налаштування",
    "settings.copy_key": "Скопіювати ключ",
    "settings.enter_code_title": "Введіть код",
    "settings.authy": "Authy",
    "settings.duo": "Duo Mobile",

    "settings.2Step_text1":
      "Введіть ваш номер телефону, щоб отримати код двоетапної перевірки",
    "settings.2Step_text2":
      "Введіть код підтвердження, згенерований вашим телефоном, що закінчується на",
    "settings.lang.ru": "Російська",
    "settings.time_zone": "Часовий пояс",
    "settings.avatar.photo": "Фото",
    "settings.avatar.upload_description": "Завантажте фото профілю",
    "settings.avatar.delete": "Видалити",
    "settings.avatar.upload": "Завантажити",
    "settings.avatar.select_image":
      "Будь ласка, виберіть зображення (JPG, PNG, GIF або WebP)",
    "settings.avatar.file_too_large":
      "Файл занадто великий. Максимальний розмір: 5 МБ",
    "settings.lang.ua": "Українська",
    "settings.active_sessions": "Активні сесії",
    "settings.last_activity": "Остання активність",
    "settings.ip": "IP",
    "settings.device_os": "Пристрій/ОС",
    "settings.browser": "Браузер",
    "settings.country": "Країна",
    "settings.city": "Місто",

    "settings.disabled": "Вимкнути",
    "settings.enabled": "Увімкнено",
  },
};

export default settings;
